import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { CALCULATION_TYPE } from 'domains/payment-method/constants'

const propTypes = {
  calculationType: PropTypes.string
}

/**
 * @param {string} status
 */
const PaymentMethodCalculationTypeBadge = ({ calculationType }) => {
  const colorMap = {
    [ CALCULATION_TYPE.ABSOLUTE ]   : 'info',
    [ CALCULATION_TYPE.PERCENTAGE ] : 'warning'
  }

  const color = colorMap[ calculationType ] || 'default'

  return <StatusBadge color={ color } label={ calculationType } />
}

PaymentMethodCalculationTypeBadge.propTypes = propTypes

export default PaymentMethodCalculationTypeBadge
